module.exports = __webpack_public_path__ + "img/zuanshi@2x.89717e3a.png";